import React from "react"
import { MDXProvider } from "@mdx-js/react"
import Code from "./code_block"

const components = {
  h2: props => (
    <h2
      style={{
        fontFamily:
          "Montserrat,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif",
      }}
      {...props}
    />
  ),
  h1: props => (
    <h1
      style={{
        fontFamily:
          "Montserrat,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif",
      }}
      {...props}
    />
  ),
  a: props => (
    <a
      style={{
        color: "#0d3c82",
        backgroundColor: "rgba(23,105,227,.08)",
        padding: 3,
        borderRadius: 4,
        textDecoration: "none",
        fontFamily:
          "Montserrat,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif",
      }}
      {...props}
    />
  ),
  table: props => (
    <table
      style={{
        maxWidth: 700,
        border: "0.5px solid lightgrey",
      }}
      {...props}
    />
  ),
  th: props => (
    <th
      style={{
        paddingLeft: "1rem",
        borderRight: "0.5px solid lightgrey",
      }}
      {...props}
    />
  ),
  td: props => (
    <th
      style={{
        paddingLeft: "1rem",
        fontWeight: 400,
        borderRight: "0.5px solid lightgrey",
      }}
      {...props}
    />
  ),
  figcaption: props => (
    <figcaption
      style={{
        fontSize: 15,
        color: "707070",
        width: "70%",
        display: "flex",
        flexWrap: "wrap",
        marginTop: -30,
        color: "GrayText",
        textAlign: "center",
      }}
      {...props}
    />
  ),
  img: props => (
    <img
      style={{
        width: "70%",
      }}
      {...props}
    />
  ),
  hr: props => (
    <hr
      style={{
        width: "85%",
      }}
      {...props}
    />
  ),
  pre: props => <Code {...props} />,
  wrapper: ({ children }) => <>{children}</>,
}

export const wrapRootElement = ({ element }) => {
  return <MDXProvider components={components}>{element}</MDXProvider>
}
